import { render, staticRenderFns } from "./centerGrid.vue?vue&type=template&id=0e0dc206&scoped=true&"
import script from "./centerGrid.vue?vue&type=script&lang=js&"
export * from "./centerGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0dc206",
  null
  
)

export default component.exports